import { SCAN_ACTION_EXECUTION_REGISTRY } from '../constants/scanActionExecutionRegistry.const';
import { OPEN_ORDER_DRAWER_SCAN_ACTION_NAME } from '../constants/scanActionNames.const';
import { type ScanAction, type ScanActionResult } from '../types/scanAction.type';
import { type ScanEvent } from '../types/scanEvent.type';

const isOrderDrawerMatch = (scanEvent: ScanEvent) => {
  const barcodeContent = scanEvent.scan_context.barcode_content;
  if (!barcodeContent) return false;

  const { route, ui } = scanEvent.scan_context;
  if (route.route === 'orders') {
    return (
      !ui.open_drawer ||
      ui.selected_order_object_id !== barcodeContent.order_object_id ||
      ui.selected_shipment_id !== barcodeContent.shipment_id
    );
  }

  if (route.route === 'shipments') {
    if (!barcodeContent.transaction_object_id) return false;
    return (
      !ui.open_drawer ||
      ui.selected_order_object_id !== barcodeContent.order_object_id ||
      ui.selected_transaction_object_id !== barcodeContent.transaction_object_id
    );
  }

  return false;
};

export const createOpenOrderDrawerScanAction = (): ScanAction => ({
  execute: (scanEvent: ScanEvent): ScanActionResult => {
    SCAN_ACTION_EXECUTION_REGISTRY.execute(OPEN_ORDER_DRAWER_SCAN_ACTION_NAME, scanEvent);
    return { success: true };
  },

  matches: (scanEvent) =>
    SCAN_ACTION_EXECUTION_REGISTRY.has(OPEN_ORDER_DRAWER_SCAN_ACTION_NAME) &&
    scanEvent.barcode_value.startsWith('ORD') &&
    isOrderDrawerMatch(scanEvent),

  name: OPEN_ORDER_DRAWER_SCAN_ACTION_NAME,
});
